import React from 'react';
import { FormattedMessage } from 'react-intl';
import SectionHeader from '../../components/SectionHeader/SectionHeader';
import useBreadCrumbs from '../../hooks/breadCrumbs/useBreadCrumbs';
import BestAskPrices from '../PublicAskPriceELEPage/components/BestAskPrices/BestAskPrices';

const PublicAskPriceTHEPage = () => {
  useBreadCrumbs(<FormattedMessage id={'app.publicaskprice.the'} />);
  return (
    <>
      <SectionHeader>
        <FormattedMessage id={'app.publicaskprice.the'} />
      </SectionHeader>
      <BestAskPrices commodity={'GAS_THE'} />
    </>
  );
};

export default PublicAskPriceTHEPage;
